import { withStyles } from '@material-ui/core';
import React from 'react';
import Events from '../../../../../utilities/EventEmitter';
import { APP_EVENT_NAMES } from '../../../../../signalR/constants';
import { getInternationalNumberFormat } from '../../../../../utilities/appHelper';

const styles = (theme) => ({
  container: {
    display: 'flex',
    gap: '20px',
    marginBottom: 12
  },
  blockContainer: {
    padding: '10px 14px',
    border: `1px solid ${theme.KPI.KPIButton}`,
    borderRadius: 4,
    color: theme.TextColor,
    fontWeight: 400,
    flexGrow: 1
  },
  value: {
    color: theme.disableButtonText,
    fontSize: theme.headerTextFontSize16,
    fontWeight: 600,
    marginBottom: 4
  },
  clickableValue: {
    textDecoration: `underline ${theme.disableButtonText}`,
    cursor: 'pointer'
  }
});

const FeedbackSummaryHeader = ({ data, classes }) => {
  const openUNRTDshipmentsModal = () => {
    Events.emit(APP_EVENT_NAMES.IBPLANNING.openUnrtdModal);
  };

  const details = [
    {
      label: 'Total Routes',
      value: data?.totalRoutes
    },
    {
      label: 'Total Miles',
      value: getInternationalNumberFormat(data?.totalMiles?.toFixed(2))
    },
    {
      label: 'Total Stops',
      value: data?.totalStops
    },
    {
      label: 'LG Routes',
      value: data?.lgRoutes
    },
    {
      label: 'Anchor Points',
      value: data?.anchorPointsCount
    },
    {
      label: 'UNRTD Shipments',
      value: data?.unroutedShipments,
      onValueClick: openUNRTDshipmentsModal
    }
  ];
  return (
    <div className={classes.container}>
      {details.map((item) => (
        <div className={classes.blockContainer}>
          <div
            className={`${classes.value} ${item.onValueClick ? classes.clickableValue : ''}`}
            onClick={item.onValueClick ?? null}>
            {item.value}
          </div>
          <div>{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(FeedbackSummaryHeader);
